module.exports = __webpack_public_path__ + "img/transaction_intro_01@2x.650db870.png";